import { render } from "./TrainTeacherListView.vue?vue&type=template&id=b7650b90&scoped=true"
import script from "./TrainTeacherListView.vue?vue&type=script&lang=js"
export * from "./TrainTeacherListView.vue?vue&type=script&lang=js"

import "./TrainTeacherListView.vue?vue&type=style&index=0&id=b7650b90&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7650b90"]])

export default __exports__